import { render } from "./Cell.vue?vue&type=template&id=87ecf392&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=87ecf392&lang=scss&scoped=true"

import exportComponent from "/Users/edu/Documents/Labbet/lingobingo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ecf392"]])

export default __exports__